import { render, staticRenderFns } from "./LikertResponseChart.vue?vue&type=template&id=420df5f4&scoped=true&"
import script from "./LikertResponseChart.vue?vue&type=script&lang=js&"
export * from "./LikertResponseChart.vue?vue&type=script&lang=js&"
import style1 from "./LikertResponseChart.vue?vue&type=style&index=1&id=420df5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420df5f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
